import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dffe3174"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "caution-area" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center caution mb-2"
}
const _hoisted_3 = { class: "ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.cautionMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_FeatherIcon, {
            icon: "alert-triangle",
            size: "24"
          }),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.cautionMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}